import React from 'react';

const Button = ({
  className,
  onClick,
  title = 'N/A',
  ...rest
}) => (
  <button
    type="button"
    title={title}
    onClick={onClick}
    className={`header-btn ${className}`}
  >
    {rest.children && rest.children}
    {title}
  </button>
);

export default Button;
